document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".shop-concern-section");
  if (!section) return;

  const progress = section.querySelector(".progress-fill");
  const currentSlide = section.querySelector(".current-slide");
  const totalSlides = section.querySelector(".total-slides");

  // Desktop Select
  const select = section.querySelector(".shop-concern-btn");

  // Mobile Tabs
  const mobileTabs = section.querySelectorAll(".collection-tab");

  // Store original slides
  const allSlides = Array.from(
    section.querySelectorAll(".concernSwiper .swiper-slide")
  ).map((slide) => slide.cloneNode(true));

  // Swiper Init
  window.concernSwiper = new Swiper(section.querySelector(".concernSwiper"), {
    slidesPerView: 3.5,
    spaceBetween: 15,
    speed: 600,
    watchOverflow: true,
    grabCursor: true,

    mousewheel: {
      invert: false,
      sensitivity: 1,
    },

    navigation: {
      nextEl: section.querySelector(".slider-next"),
      prevEl: section.querySelector(".slider-prev"),
    },

    // pagination: {
    //   el: section.querySelector(".swiper-pagination"),
    //   clickable: true,
    //   dynamicBullets: true,
    // },

    breakpoints: {
      0: {
        slidesPerView: 1.2,
      },
      768: {
        slidesPerView: 2.1,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 2.5,
      },
      1280: {
        slidesPerView: 3.55,
      },
    },

    on: {
      init() {
        updateProgress(this);
        updateArrows(this);
      },

      slideChange() {
        updateProgress(this);
        updateArrows(this);
      },

      resize() {
        updateProgress(this);
        updateArrows(this);
      },
    },
  });

  const swiper = window.concernSwiper;

  // Progress
  function updateProgress(swiper) {
    const totalSlidesCount = swiper.slides.length;

    let visibleSlides = swiper.params.slidesPerView;

    if (typeof visibleSlides !== "number") {
      visibleSlides = swiper.slidesPerViewDynamic();
    }

    const totalPages = Math.max(
      totalSlidesCount - Math.floor(visibleSlides) + 1,
      1
    );

    const currentPage = Math.min(swiper.activeIndex + 1, totalPages);

    progress.style.width = `${(currentPage / totalPages) * 100}%`;

    currentSlide.textContent = String(currentPage).padStart(2, "0");
    totalSlides.textContent = String(totalPages).padStart(2, "0");
  }

  // Arrow State
  function updateArrows(swiper) {
    const prev = section.querySelector(".slider-prev");
    const next = section.querySelector(".slider-next");

    prev.disabled = swiper.isBeginning;
    next.disabled = swiper.isEnd;

    prev.classList.toggle("disabled", swiper.isBeginning);
    next.classList.toggle("disabled", swiper.isEnd);
  }

  // View Collection button
  const viewAllBtn = section.querySelector(".js-concern-viewall");

  // Filter Function
  function filterCollection(selectedCollection) {
    if (viewAllBtn && selectedCollection && selectedCollection !== "all") {
      viewAllBtn.href = "/collections/" + selectedCollection;
    }

    swiper.removeAllSlides();

    const filteredSlides = allSlides.filter((slide) => {
      return (
        selectedCollection === "all" ||
        slide.dataset.collection === selectedCollection
      );
    });

    swiper.appendSlide(filteredSlides);

    swiper.update();
    swiper.slideTo(0, 0);

    updateProgress(swiper);
    updateArrows(swiper);
  }

  // Desktop Select
  if (select) {
    filterCollection(select.value);

    select.addEventListener("change", function () {
      filterCollection(this.value);

      // Sync Mobile Active Tab
      mobileTabs.forEach((tab) => {
        tab.classList.toggle(
          "active",
          tab.dataset.collection === this.value
        );
      });
    });
  }

  // Mobile Tabs
  if (mobileTabs.length) {
    mobileTabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        mobileTabs.forEach((item) => item.classList.remove("active"));
        this.classList.add("active");

        const collection = this.dataset.collection;

        // Sync Desktop Select
        if (select) {
          select.value = collection;
        }

        filterCollection(collection);
      });
    });

    // Initial filter if no select exists
    if (!select) {
      const activeTab =
        section.querySelector(".collection-tab.active") || mobileTabs[0];

      if (activeTab) {
        filterCollection(activeTab.dataset.collection);
      }
    }
  }
});